<template>
  <b-modal id="open-licence-modal"
    class="basic-modal no-header-modal hide-cancel-btn"
    no-close-on-backdrop
    no-close-on-esc
    :hide-header="false"
    :title="$t('not_support_prime.title')"
    @ok="$emit('ok')"
    :ok-title="$t('common.confirm')">
    <div>
      <div v-html="$t('not_support_prime.description')" />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'licence-modal',
};
</script>
